import styled from "styled-components";

export const Footer = styled.footer`
  display: grid;
  grid-template-columns: 2.8fr 2fr;
  justify-content: center;
  align-items: center;
  grid-gap: 36px;
  height: 82px;
  border-bottom: 3px solid #ff9029;
  .container-img {
    position: relative;
    display: flex;
    justify-content: flex-start;
    img {
      &:first-child {
        margin-left: 36px;
      }
    }
    &:before {
      content: "";
      display: block;
      width: 1px;
      height: 34px;
      background-color: #343434;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0px;
    }
  }

  .span-footer {
    font-size: 12px !important;
  }

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #343434;
    &:first-child {
      margin-left: auto;
    }
    &:last-child {
      margin-right: auto;
    }
  }

  @media (max-width: 1366px) {
    span {
      width: 90%;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    .container-img {
      display: none;
    }
    span {
      display: none;
      margin: 0px;
      &:first-child {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 250px;
      }
    }
  }
`;
